<template>
  <v-app-bar app elevation="2" class="white">
    <v-app-bar-nav-icon class="d-lg-none" @click="$store.commit('TOGGLE_MAIN_NAV')"></v-app-bar-nav-icon>
    <slot name="goBack"></slot>
    <v-toolbar-title>{{title}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <slot name="buttons"></slot>
  </v-app-bar>
</template>
<script>
  export default {
    name: 'MainAppBar',
    props: ['title'],
    data: () => ({
    })
  }
</script>
